import { SET_COLLECTION_LIST, DELETE_FROM_COLLECTION_LIST,
  SET_COLLECTION_PLAYLIST, ADD_COLLECTION_PLAYLIST, REMOVE_COLLECTION_PLAYLIST,
  SET_COLLECTION_ARRANGEMENT_PLAYLIST,
  ADD_COLLECTION_ARRANGEMENT_TO_PLAYLIST,
  REMOVE_COLLECTION_ARRANGEMENT_FROM_PLAYLIST,
  SET_COLLECTION_AUTHORS, SET_COLLECTION_GENRES } from '../constants/collection';

const initialState = {
  listCount: 0,
  list: [],
  playlists: [],
  authors: [],
  genres: [],
  arrangementPlaylists: {}
};

const collectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COLLECTION_LIST:
      return {
        ...state,
        listCount: action.list.length,
        list: action.list.map(
          p => {
            p.title=p.offer_info.title;
            p.difficulty=p.offer_info.difficulty;
            p.tonality=p.offer_info.tonality;
            p.author=p.offer_info.author;
            p.author_id=p.offer_info.user_created;
            p.performer=p.offer_info.performer_name;
            p.performer_id=p.offer_info.performer || 0;
            return p;
          }
        ),
      };
    case DELETE_FROM_COLLECTION_LIST:
      const newList = state.list.filter(o => !action.ids.includes(o.offer_info.id));
      return {
        ...state,
        listCount: newList.length,
        list: newList,
      };
    case SET_COLLECTION_PLAYLIST:
      return {
        ...state,
        playlists: action.list
      };
    case ADD_COLLECTION_PLAYLIST:
      return {
        ...state,
        playlists: [...state.playlists, action.newPlaylist]
      };
    case REMOVE_COLLECTION_PLAYLIST:
      return {
        ...state,
        playlists: state.playlists.filter(p => p.id != action.id)
      };
    case SET_COLLECTION_ARRANGEMENT_PLAYLIST:
      return {
        ...state,
        arrangementPlaylists: {...state.arrangementPlaylists, [action.offer]: action.list}
      };
    case ADD_COLLECTION_ARRANGEMENT_TO_PLAYLIST:
      return {
        ...state,
        arrangementPlaylists: {...state.arrangementPlaylists,
          [action.offer]: [...state.arrangementPlaylists[action.offer], action.playlist]}
      };
    case REMOVE_COLLECTION_ARRANGEMENT_FROM_PLAYLIST:
      return {
        ...state,
        arrangementPlaylists: {...state.arrangementPlaylists,
          [action.offer]: state.arrangementPlaylists[action.offer].filter(i => i != action.playlist)
        }
      };
    case SET_COLLECTION_AUTHORS:
      return {
        ...state,
        authors: [...action.list]
      };
    case SET_COLLECTION_GENRES:
      return {
        ...state,
        genres: [...action.list]
      };
    default:
      return state;
  }
};

export default collectionReducer;